import { connect } from 'react-redux';
import ChangePasswordComponent from './ChangePassword';
import {
  isChangingPassword,
  getCurrentPassword,
  getCurrentPasswordError,
  getNewPassword,
  getNewPasswordError,
  getError,
  shouldShowCurrentPasswordError,
  shouldShowNewPasswordError,
  canChangePassword,
  passwordChanged,
} from '../../../state/reducers/ChangePasswordReducer';
import SignupActions from '../../../state/actions/ChangePasswordActions';

const mapStateToProps = (state) => ({
  isChangingPassword: isChangingPassword(state),
  currentPassword: getCurrentPassword(state),
  currentPasswordError: shouldShowCurrentPasswordError(state)
    ? getCurrentPasswordError(state)
    : '',
  newPassword: getNewPassword(state),
  newPasswordError: shouldShowNewPasswordError(state)
    ? getNewPasswordError(state)
    : '',
  changePasswordError: getError(state),
  canChangePassword: canChangePassword(state),
  passwordChanged: passwordChanged(state),
});

const { changePasswordRequest, currentPasswordChanged, newPasswordChanged } =
  SignupActions;

export default connect(mapStateToProps, {
  changePassword: changePasswordRequest,
  currentPasswordChanged,
  newPasswordChanged,
})(ChangePasswordComponent);



// WEBPACK FOOTER //
// ./src/view/forms/ChangePassword/index.js